<template>
  <div class="select-sku-box">
    <div class="trigger-box">
      <span class="selectNumBox">
        已选择<span class="num">{{ (productList || []).length }}</span
        >个
      </span>
      <bi-button type="blueText" @click="handleClick">选择商品</bi-button>
    </div>
    <!-- 引入刚刚创建的弹窗组件 -->
    <select-sku-dialog
      :showModal.sync="dialogVisible"
      :selectedProductList="productList"
      :subSystemSellerId="subSystemSellerId"
      :dataType="dataType"
      v-bind="$attrs"
      v-on="$listeners"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    ></select-sku-dialog>
  </div>
</template>

<script>
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import SelectSkuDialog from "./selectSkuDialog.vue";

export default {
  name: "SelectSkuCom",
  inheritAttrs: false, // 阻止 $attrs 绑定到根元素上
  components: {
    SelectSkuDialog,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    subSystemSellerId: {
      type: String,
      default: "",
    },
    dataType: {
      type: String,
      default: "sku",
    },
    initFormData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      productList: [], // 存放完整的商品对象数据
    };
  },
  watch: {
    value: {
      handler(newVal) {
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        const currentIds = this.productList.map((item) => item[idKey]);
        if (!isEqual(newVal, currentIds)) {
          if (!newVal || newVal.length === 0) {
            this.productList = [];
          } else {
            this.productList = newVal.map((id) => {
              const existItem = this.productList.find(
                (item) => item[idKey] == id,
              );
              return existItem ? existItem : { [idKey]: id };
            });
          }
        }
      },
      immediate: true,
      deep: true,
    },
    subSystemSellerId(newVal, oldVal) {
      if (newVal != oldVal && oldVal != "") {
        this.reset();
      }
    },
  },
  mounted() {
    // 组件挂载时触发初始化事件
    this.$emit("initSku", "sku");
  },
  methods: {
    reset() {
      // 重置数据
      this.productList = [];
      this.$emit("input", []);
    },
    handleClick() {
      this.dialogVisible = true;
      this.$emit("click");
    },
    handleConfirm(selectedItems) {
      if (selectedItems) {
        this.productList = cloneDeep(selectedItems);
        const idKey = this.dataType === "sku" ? "skuId" : "itemId";
        const ids = this.productList.map((item) => item[idKey]);
        this.$emit("input", ids);
      }
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-sku-box {
  width: 300px;
  .trigger-box {
    height: 30px;
    line-height: 30px;
    padding: 0 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 300px;
    background: #fff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdee1;

    &:hover,
    &.is-active {
      border-color: #3159ff;
    }
    .trigger-text {
      font-size: 14px;
      color: #606266;
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectNumBox {
      background: #f5f5f5;
      border-radius: 2px 2px 2px 2px;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 8px;
      .num {
        color: #ff7f23;
        padding: 0 2px;
      }
    }
  }
}
</style>
